var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6h16",
    className: "hamburger_svg__hamburger_line1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16",
    className: "hamburger_svg__hamburger_line2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18h16",
    className: "hamburger_svg__hamburger_line3"
  })));
};
export default SvgHamburger;